export default __webpack_public_path__ + "static/media/pantry1-afterA-1920w.f6585d2b.avif";